import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import secureSessionStorage from "./utils/secureSessionStorage";

const secureAutherization = secureSessionStorage.getItem("Authorization");
const secureNgsmtoken = secureLocalStorage.getItem("ngsmtoken");
console.log("axios.js", secureNgsmtoken, secureAutherization, window.isPortalLive)
const secureAutherization1 = window.isPortalLive
  ? secureLocalStorage.getItem(`launchpadKey_${window.applicationName}`) ||  secureLocalStorage.getItem("launchpadKey")
  : secureLocalStorage.getItem("launchpadKey");
const jwtToken = secureAutherization || JSON.parse(secureAutherization1)?.token || secureSessionStorage.getItem("Authorization") || undefined;
console.log("axios.js1", jwtToken)
const externalIformUrl = document?.URL || document?.baseURI || document?.documentURI;
const ngsmtoken = window.isPortalLive || externalIformUrl?.includes("openExtInterface") ? secureNgsmtoken : undefined;
console.log("axios.js2", ngsmtoken, externalIformUrl)

const base_address = window?.["psh_configs"]?.backEndUrl;

const instance = axios.create({}, { headers: {} });

instance.defaults.headers.common["Authorization"] = jwtToken;
if(window.isPortalLive || externalIformUrl?.includes("openExtInterface")){
  if(ngsmtoken)
  instance.defaults.headers.common["ngsmtoken"] = ngsmtoken;
} 
  
instance.defaults.headers.common["cabinetName"] = window.activeCabinet_formbuilder;

const isWindowButtonSubform = externalIformUrl?.includes("afb_subform");
instance.defaults.baseURL = isWindowButtonSubform
  ? window.opener?.apb_backend_app_context || window.apb_backend_app_context || base_address
  : window.apb_backend_app_context || base_address;

if (isWindowButtonSubform && window.opener?.newMicroFrontendData?.authData) {
  const openerAuth = window.opener.newMicroFrontendData.authData;
  if (openerAuth.Authorization) instance.defaults.headers.common["Authorization"] = openerAuth.Authorization;
  if (openerAuth.ngsmtoken) instance.defaults.headers.common["ngsmtoken"] = openerAuth.ngsmtoken;
  if (openerAuth.cabinetName) instance.defaults.headers.common["cabinetName"] = openerAuth.cabinetName;
}

export default instance;
